import { combineReducers } from 'redux';
import appTheme from './appTheme';
import search from './search';
import authentication from './authentication';
import profileDetails from './profileDetails';
import userActivity from './userActivity';
import preferences from './preferences';
import userSubscription from './userSubscription';
import userDiscount from './userDiscount';
import courses from './courses';
import personaliseCourse from './personaliseCourse'
import { LOGOUT_REQUEST } from '../actions/types';
import storage from 'redux-persist/lib/storage'
import location from './location';
import certificateVerification from './certificateVerification';
import hallOfFame from './hallOfFame';
import userBannerData from './userBannerData';
import onBoarding from './onBoarding';
import personaliseLessons from '../personaliseLessons';
import roadmapV2 from './roadmapV2';

const appReducer = combineReducers({
    authentication,
    profileDetails,
    search,
    userActivity,
    appTheme,
    preferences,
    location,
    userSubscription,
    userDiscount,
    courses,
    personaliseCourse,
    certificateVerification,
    hallOfFame,
    userBannerData,
    onBoarding,
    personaliseLessons,
    roadmapV2
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT_REQUEST) {
        storage.removeItem('persist:v2')
        localStorage.clear()
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;